import { LayoutBindingHandler } from "../../../Syntess.Web.Shared/Knockout/LayoutBindingHandler";
import { IconBindingHandler } from "./IconBindingHandler";
import * as DateTimeUtils from "../../../Syntess.Web.Shared/Utils/DateTimeUtils";
import * as StringUtils from "../../../Syntess.Web.Shared/Utils/StringUtils";
import * as Selection from "../../../Syntess.Web.Shared/Utils/Selection";
import * as ExterneDocumenten from "../../../Syntess.Web.Shared/ExterneDocumenten";
import * as ViewUtils from "../../../Syntess.Web.Shared/Utils/ViewUtils";
import * as UI from "../../../Syntess.Web.Shared/UI";
import * as WebMethods from "../../../Syntess.Web.Shared/WebMethods";
import { isEnterKeyPressed, setDefaultValue, checkEmailAddressOrListValid, checkVerplichtEmailAddressValid, updateUrlParameter, checkEmailAddressValid } from "../../../Syntess.Web.Shared/Utils/Utils";
import { CallManager } from "../../../Syntess.Web.Shared/CallManager";
import * as Browser from "../../../Syntess.Web.Shared/Utils/Browser";
import * as Core from "../../../Syntess.Web.Shared/Core";
import { DetailsViewModel } from "../../../Syntess.Web.Shared/Data/DetailsViewModel";
import { ChangedFlag } from "../../../Syntess.Web.Shared/Knockout/ChangedFlag";
import { WachtwoordViewModel } from "../../../Syntess.Web.Shared/Viewmodels/Wachtwoord";
import * as ImageUtils from "../../../Syntess.Web.Shared/Utils/ImageUtils";
import * as SafariRedirect from "../../../Syntess.Web.Shared/SafariRedirect";
import * as Hyperlink from "../../../Syntess.Web.Shared/Utils/Hyperlink";
import * as ColorUtils from "../../../Syntess.Web.Shared/Utils/ColorUtils";
import * as Groepen from "../../Views/Groepen/Groepen";
import { pdfType } from "../../../Syntess.Web.Shared/pdfType";
import { StopBindingBindingHandler } from "../../../Syntess.Web.Shared/Knockout/StopBindingBindingHandler";
import { DateBindingHandler } from "../../../Syntess.Web.Shared/Knockout/DateBindingHandler";
import { AfbeeldingBindingHandler } from "./AfbeeldingBindingHandler";
import { CanvasBindingHandler } from "./CanvasBindingHandler";
import { CookieUtils } from "./CookieUtils";
import { AantalBindingHandler } from "../../../Syntess.Web.Shared/Knockout/AantalBindingHandler";
import { TextJNBindingHandler } from "../../../Syntess.Web.Shared/Knockout/TextJNBindingHandler";
import { i18n, LanguageSources } from "../../../Syntess.Web.Shared/I18n";
import * as nlShared from "../../../Syntess.Web.Shared/Locales/shared-nl.json";
import * as i18nMapShared from "../../../Syntess.Web.Shared/Locales/shared-map.json";
import { PortalSessieChecker } from "./PortalSessieChecker";
import { PortalUserSettings } from "./PortalUserSettings";

export abstract class BaseBundle {
    protected constructor(useSessieChecker = true) {
        this.extendSyntessTsNamespaceForJavaScript();

        this.loadI18n();

        this.addBindingHandlers();
        if (useSessieChecker) {
            this.startSessieChecker();
        }
    }

    private startSessieChecker() {
        window.document.addEventListener("DOMContentLoaded", () => {
            const userSettingsString = (document.getElementById("usersettings") as HTMLInputElement).value;
            const portalUserSettings = new PortalUserSettings(userSettingsString);
            new PortalSessieChecker(portalUserSettings, window.localStorage, window);
        });
    }

    private extendSyntessTsNamespaceForJavaScript() {
        const syntessTS = {
            CallManager: CallManager,
            Core: Core,
            Data: {
                DetailsViewModel: DetailsViewModel
            },
            ExterneDocumenten: ExterneDocumenten,
            Knockout: {
                ChangedFlag: ChangedFlag
            },
            Portal: {
                Brieven: {
                    pdfType: pdfType
                },
                Views: {
                    Groepen: Groepen
                }
            },
            Safari: SafariRedirect,
            UI: {
                alert: UI.showAlert,
                confirm: UI.showConfirm,
                NotificationResult: UI.NotificationResult,
                setupMessage: UI.setupMessage,
                ShowPopup: UI.ShowPopup,
                ShowPopupWithId: UI.ShowPopupWithId,
                TypeMessage: UI.TypeMessage
            },
            Utils: {
                checkEmailAddressValid: checkEmailAddressValid,
                checkEmailAddressOrListValid: checkEmailAddressOrListValid,
                checkVerplichtEmailAddressValid: checkVerplichtEmailAddressValid,
                isEnterKeyPressed: isEnterKeyPressed,
                setDefaultValue: setDefaultValue,
                updateUrlParameter: updateUrlParameter,
                Browser: Browser,
                Color: ColorUtils,
                Cookie: CookieUtils,
                Datetime: DateTimeUtils,
                Hyperlink: Hyperlink,
                ImageUtils: ImageUtils,
                Selection: Selection,
                String: StringUtils,
                View: ViewUtils
            },
            Viewmodels: {
                WachtwoordViewModel: WachtwoordViewModel
            },
            WebMethods: WebMethods
        };
        (window as any).SyntessTS = $.extend(true, (window as any).SyntessTS, syntessTS);
    }

    private addBindingHandlers() {
        if (typeof ko !== "undefined") {
            ko.bindingHandlers.date = new DateBindingHandler();
            ko.bindingHandlers.icon = new IconBindingHandler();
            ko.bindingHandlers.layout = new LayoutBindingHandler();
            ko.bindingHandlers.stopBinding = new StopBindingBindingHandler();
            ko.bindingHandlers.afbeelding = new AfbeeldingBindingHandler();
            ko.bindingHandlers.canvas = new CanvasBindingHandler();
            ko.bindingHandlers.aantal = new AantalBindingHandler();
            ko.bindingHandlers.textJN = new TextJNBindingHandler();
        }
    }

    private loadI18n() {
        const sharedLanguageSources: LanguageSources = {
            importLanguage: function (language: string): PromiseLike<{}> {
                // In ES2017 kan dit dynamisch worden geladen met behulp van de language variable
                switch (language) {
                    case "en": return import("../../../Syntess.Web.Shared/Locales/shared-en.json");
                    case "de": return import("../../../Syntess.Web.Shared/Locales/shared-de.json");
                    default: return Promise.resolve<Object>({});
                }
            }
        };
        i18n.addLanguageModule(nlShared, i18n.createLanguageModule('shared', sharedLanguageSources));
        (i18n as any).shared = i18nMapShared;
    }
}
